export default {
  bundleName: 'AppyHere Recruiter',
  firstName: 'AppyHere',
  lastName: 'Recruiter',
  loading: 'AppyHere…',
  loadingCandidate: 'Loading Candidate...',
  deviceDetect: {
    header: "Our bad, we're still working on AppyHere for mobile browsers!",
    message: 'We strongly recommend you use a desktop for an optimal experience.',
  },
  exitPromptMessage: 'Any unsaved changes to your form will be lost. Are you sure you want to leave?',
  forbidden: {
    title:
      "You are currently logged in as a co-interviewer. To access Recruiter Web's features, you'll need to sign out of your current session.",
    message:
      'Note that you cannot be logged into co-interviewer and regular sessions simultaneously. Use the Sign Out button below to be able to log in with your Recruiter Web account.',
    goHome: 'Go to homepage',
    signOut: 'Sign Out & Go to Homepage',
    goBack: 'Return',
  },
};
